function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as o } from "./index.es33.js";
import { clsx as m } from "./index.es105.js";
import { t as l } from "./index.es106.js";
import { Typography as n } from "./index.es35.js";
import "./index.es36.js";
import { Link as s } from "./index.es42.js";
import "./index.es13.js";
import { TooltipShorten as c } from "./index.es14.js";
import "./index.es15.js";
import t from "./index.es222.js";

var B = function B(_ref) {
  var r = _ref.fileName,
      i = _ref.isDisabled,
      e = _ref.onCancelHandler;
  return o.jsxs("div", {
    className: m(t.container, _defineProperty({}, t.disabled, i)),
    children: [o.jsx(n.Body2, {
      as: "div",
      className: t.fileName,
      children: o.jsx(c, {
        title: r,
        children: r
      })
    }), o.jsx(s, {
      className: m(_defineProperty({}, t.disabledButton, i)),
      kind: s.LinkKind.button,
      onClick: e,
      children: o.jsx(n.Small, {
        children: l("component_commonKeys_cancelButton_cancelButton")
      })
    })]
  });
};

export { B as FileImport };